import { setsTableStyle } from "features/products/index.styles";

export const mapFrameContentStyles = {
  "& .MuiCardContent-root": {
    p: "unset !important",
  },
  m: "unset",
  p: "unset !important",
};

export const headerButtonMobile = {
  padding: "0px !important",
  width: "100% !important",
  marginTop: "12px",
};

export const mapFrameCardSXStyles = {
  m: "unset",
  p: "24px 16px",
  borderColor: "#EEEEEE",
};

export const orderDetailsHeading = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: "6px 20px",
  borderRadius: "12px",
  ml: "10px",
};

export const currencyStyles = {
  fontStyle: "normal",
  fontSize: "10px",
  color: "#757575",
  pb: "1.85px !important",
};

export const searchNoDataStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #EEEEEE",
  p: "18px",
  mb: "24px",
};

export const bulkOrderConversionStyle = {
  "& .MuiSvgIcon-root": {
    color: "#212121",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiOutlinedInput-root input::placeholder": {
    color: "#212121",
    opacity: 1,
    fontSize: 13,
    fontWeight: "500",
  },

  "& .MuiOutlinedInput-root": {
    height: "41px",
    borderRadius: "58px",
    background: "#F5F5F5",

    "& fieldset": {
      borderColor: "#bababa",
      borderWidth: 0.8,
    },
    "&:hover fieldset": {
      borderColor: "#e51451",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 0.8,
      borderColor: "#e51451",
    },
    "&.MuiOutlinedInput-root input": {
      color: "#212121",
      fontSize: 13,
      fontWeight: "500",
    },

    "&.MuiOutlinedInput-root .MuiTypography-root": {
      color: "#545454",
      fontSize: 13,
      fontWeight: "200",
    },
    "& .MuiOutlinedInput-input": {
      padding: "2px !important",
      background: "#F5F5F5",
    },
  },
};

export const gridIconsCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  color: "#212121",
};

export const filtersStyles = {
  width: { xs: "100%", md: "160px" },
  height: "40px",
  ml: { sm: "10px" },
  mb: { xs: "10px", sm: "0" },
};

export const halfMarginBottom = { mb: 0.5 };

export const mainCardSX = {
  m: "unset",
  borderRadius: "unset",
  border: "none",
  p: {
    xs: "22px 15px",
    md: "35px 40px",
    lg: "48px 55px",
  },
};

export const responsiveAlignmentStart = {
  mt: "14px",
  justifyContent: {
    xs: "flex-start",
    md: "end",
  },
  textAlign: {
    xs: "flex-start",
    md: "end",
  },
};

export const responsiveAlignmentEnd = {
  mt: "14px",
  justifyContent: {
    xs: "flex-end",
    md: "end",
  },
  textAlign: {
    xs: "flex-end",
    md: "end",
  },
  alignItems: "flex-end",
};

export const actionModalSX = {
  position: "absolute",
  m: "unset",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", md: "40vw" },
  p: { xs: "18px", md: "30px", lg: "40px" },
  border: "none",
};

export const imagePreviewStyles = {
  height: { xs: "30vh", md: "50vh" },
  width: { xs: "80vw", md: "25vw" },
  borderRadius: "8px",
  m: "10px",
};

export const modalPaperStyles = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", md: "65vw" },
  position: "absolute",
};

export const optionItemBoxStyles = {
  marginTop: "16px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  color: "#000000",
  borderRadius: "8px",
  marginBottom: "8px",
  p: { xs: "8px", md: "16px" },
};

export const switchMarginUnset = {
  "& .MuiFormControlLabel-root": {
    m: "unset",
  },
};

export const textAreaStyles = {
  "& .MuiOutlinedInput-root": {
    height: "unset !important",
  },

  mb: "24px",
};

export const iconStyles = { pl: "4px", color: "#979797" };

export const tooltipBoxStyles = { display: "flex", alignItems: "center" };

export const subscriptionDetailActiveStyles = {
  ...orderDetailsHeading,
  background: "#C7FFD6",
  color: "#00C853",
};

export const subscriptionDetailInactiveStyles = {
  ...orderDetailsHeading,
  background: "#FBE9E7",
  color: "#D84315",
};

export const customMadeSubscriptionStyles = {
  colStyle1: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#212121",
  },
  colStyle2: {
    fontWeight: "400",
    color: "#212121",
  },
};

export const subscriptionTitleLineStyles = {
  display: "flex",
  alignItems: { xs: "start", sm: "center" },
  flexDirection: { xs: "column", sm: "row" },
};

export const subscriptionTitleLineBoxStyles = {
  display: "flex",
  justifyContent: "space-between",
};

export const subscriptionFilterStyles = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  mb: "16px",
};

export const filtersDropDownStyles = {
  ...filtersStyles,
  ml: { xs: "0", sm: "8px" },
};

export const dataGridCheckBoxStyles = {
  mb: "20px",
  color: "#212121",
};

export const subscriptionListingTableStyles = { ...setsTableStyle, mb: "0" };

export const customerToolTipFontStyles = { fontSize: "13px" };

export const priceOuterStackStyles = { alignItems: "center" };

export const priceInnerStackStyles = { alignItems: "flex-end" };

export const priceTypographyStyles = { color: "#212121" };

export const subscriptionStatusStyles = {
  borderRadius: "100px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "13px",
};

export const activeStatusStyles = {
  ...subscriptionStatusStyles,
  background: "#C7FFD6",
  color: "#00C853",
  padding: "8px 20.4px",
  "& .MuiChip-label": {
    p: "unset",
  },
};

export const inactiveStatusStyles = {
  ...subscriptionStatusStyles,
  background: "#FBE9E7",
  color: "#D84315",
  padding: "8px 15.5px",
  "& .MuiChip-label": {
    p: "unset",
  },
};

export const customSubscriptionDetailStyles = {
  excelExportFile: {
    width: "104px",
    height: " 20px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  downloadPdf: {
    width: "92px",
    height: "20px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  pdf_print_user_phone_location_IconColor: {
    color: "#616161",
  },
  printHeading: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  tableItemNoColumn: {
    paddingLeft: "unset !important",
    paddingRight: "30px !important",
  },
};

export const orderModalPaperStyles = { height: "100%", overflowX: "auto" };

export const dividerMainCardStyles = { m: "unset", display: "none" };

export const headerMainCardStyles = { p: "unset !important", mb: "32px" };

export const contentMainCardStyles = {
  "& .MuiCardContent-root": {
    p: "unset !important",
  },
  m: "unset",
  p: "unset !important",
};

export const mainGridContainerStyles = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: { xs: "unset", md: "center" },
  position: { xs: "relative", md: "unset" },
};

export const firstInnerGridStyles = {
  display: "flex",
  alignItems: "center",
  pr: { xs: "35px !important", md: "0" },
  mb: { xs: "24px", md: "0" },
};

export const secondInnerGridStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "start", md: "end" },
};

export const centerAlignment = { alignItems: "center" };

export const normalFontBold = { fontWeight: "400" };

export const detailDateMargins = { mt: "5px" };

export const secondGridStackStyles = {
  cursor: "pointer",
  alignItems: "center",
  ml: "48px",
  position: { xs: "absolute", md: "unset" },
  top: 0,
  right: 0,
};

export const unsetp = { p: "unset" };

export const highlightOffTwoToneColor = { color: "#D84315" };

export const mobilePhoneTypoStyles = {
  maxWidth: "107px",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const orderSubscriptionDetailStyles = {
  border: "1px solid #EEEEEE",
  borderRadius: "8px",
  p: "17px 12px 24px 16px",
  mb: "16px",
  boxSizing: "border-box",
};

export const displayMdStyles = { display: { md: "flex" } };

export const displayMdGridStyles = { mb: { xs: "16px", md: "0" } };

export const displayFirstBoxStyles = {
  display: "flex",
  alignItems: { xs: "start", lg: "center" },
  border: "1px solid #EEEEEE",
  borderRadius: "8px",
  p: "10px 13px 10px 18px",
  mb: "12px",
};

export const verticalDividerStyles = {
  border: "1px solid #EEEEEE",
  display: { xs: "none", lg: "block" },
};

export const horizontalStackStyles = {
  alignItems: "center",
  justifyContent: "space-between",
};

export const defaultTopMargin = { mt: "16px" };

export const bodyTypoFontColor = { color: "#757575" };

export const TypoFontStyles = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "12px",
  color: "#757575",
};

export const cancelMainCardStyles = {
  p: "0px 16px",
  borderColor: "#EEEEEE",
  mt: 0.1,
  mb: 1.5,
};

export const boxCancelHorizontalAlign = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const typoCancelComponentBox = {
  display: "flex",
  flexDirection: "column",
  mb: 2.7,
};

export const CancelButtonFontStyles = {
  backgroundColor: "#D84315",
  width: "88px",
  height: "30px",
  borderRadius: "8px",
  mb: 2.7,
  "&:hover": {
    backgroundColor: "#D84315", // Ensure the color remains the same on hover
  },
};

export const TypoCancelButtonFontStyles = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "13px",
  lineHeight: "15px",
  color: "#fff",
};

export const TypoDetailedStyles = {
  maxWidth: "278px",
  height: "fit-content",
  boxSizing: "border-box",
  mt: "4px !important",
  marginLeft: "0px !important",
  p: "4px",
  color: "#212121",
  background: "#F8F5FC",
  border: "1px solid #673AB7",
  borderRadius: "4px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "12px",
};

export const instructionsStyles = { mt: "5px", flexWrap: "wrap" };

export const discountStyles = {
  alignItems: "center",
  mt: "5px",
  flexWrap: "wrap",
};

export const productCodeStyles = { alignItems: "center", mt: "5px" };

export const itemCountColor = { color: "#212121" };

export const dividerSXStyles = { m: "0px 0px 0px 0px !important" };

export const headerSXStyles = { p: "unset !important", mb: "20px" };

export const mainCardSXStyles = {
  m: "unset",
  p: "20px 16px 16px",
  borderColor: "#EEEEEE",
};

export const orderItemsStackStyles = {
  flexDirection: { xs: "column", md: "row" },
  justifyContent: {
    xs: "unset",
    md: "space-between",
  },
  alignItems: { xs: "unset", md: "center" },
};

export const orderItemsTypoStyles = { mb: { xs: "12px", md: "0" } };

export const calculationBoxStyles = {
  display: "flex",
  justifyContent: "end",
  background: "#F5F5F5",
  borderRadius: "8px",
  p: "24px 31px",
  mt: "2px",
};

export const spaceBetweenJustify = { justifyContent: "space-between" };

export const flexDisplayEnd = {
  display: "flex",
  alignItems: "end",
};

export const subTotalStyles = {
  ...responsiveAlignmentEnd,
  mt: "0",
};

export const totalGrandStyles = {
  ...responsiveAlignmentStart,
  mt: "0",
};

export const borderColorStyles = {
  m: "24px 0px",
  border: " 1px solid rgba(0, 0, 0, 0.06)",
};

export const alignJustifyEnd = {
  justifyContent: "flex-end",
  textAlign: "flex-end",
  alignItems: "flex-end",
};

export const magrinLeftBottomStyles = { ml: { md: "19px" } };

export const mapBoxBorderStyles = {
  p: "24px 16px",
  border: "1px solid #EEEEEE",
};

export const mapDividerStyles = { m: "0px 0px 18px 0px !important" };

export const mapHeaderStyles = { p: "unset !important", mb: "24px" };

export const currencyColumnStyles = {
  fontStyle: "normal",
  fontSize: "10px",
  color: "#757575",
};

export const eventHeaderTypoStyles = {
  display: "flex",
  marginBottom: "4px",
  width: "fit-content",
  maxWidth: "230px",
  color: "#212121",
  border: "1px solid #DB154D",
  backgroundColor: "rgba(219, 21, 77, 0.05)",
  padding: "4px 8px",
  borderRadius: "4px",
};

export const optionSetBoxStyles = {
  width: "fit-content",
  height: "fit-content",
  boxSizing: "border-box",
  mt: "4px !important",
  ml: "0px !important",
  p: "4px",
  color: "#212121",
  background: "#F8F5FC",
  border: "1px solid #673AB7",
  borderRadius: "4px",
};

export const googleMapFrameStyles = { border: "none", borderRadius: "8px" };
